import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ValidationService } from '@rentigo/ngx-common';

@Component({
  standalone: false,
  templateUrl: 'contact-dialog.component.html',
  styleUrls: ['contact-dialog.component.scss']
})
export class ContactDialogComponent {

  form!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ContactDialogComponent>,
    private validationService: ValidationService) {
    this.form = this.formBuilder.group({
      message: [null, Validators.required]
    })
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onSend() {
    this.validationService.validate(this.form);
    if (this.form.invalid) {
      return;
    }

    this.dialogRef.close(this.form.value.message);
  }
}
